/**
 * Склонение слова "генерация" по числу (1 генерация, 2 генерации, 5 генераций).
 * @param {number} n - число
 * @returns {string} - "генерация" | "генерации" | "генераций"
 */
export function generationsWord(n) {
  const num = Math.abs(Number(n));
  if (num % 100 >= 11 && num % 100 <= 14) {
    return 'генераций';
  }
  if (num % 10 === 1) {
    return 'генерация';
  }
  if (num % 10 >= 2 && num % 10 <= 4) {
    return 'генерации';
  }
  return 'генераций';
}

/**
 * Форматированная строка: "N генерация/генерации/генераций"
 * @param {number} n - число
 * @returns {string}
 */
export function generationsLabel(n) {
  const num = Number(n) ?? 0;
  return `${num} ${generationsWord(num)}`;
}

/**
 * Винительный падеж после «за» / «на одну» (цена за генерацию, экономия на генерацию).
 * @param {number} n - число
 * @returns {string} - "генерацию" | "генерации" | "генераций"
 */
export function generationsWordAccusative(n) {
  const num = Math.abs(Number(n));
  if (num % 100 >= 11 && num % 100 <= 14) {
    return 'генераций';
  }
  if (num % 10 === 1) {
    return 'генерацию';
  }
  if (num % 10 >= 2 && num % 10 <= 4) {
    return 'генерации';
  }
  return 'генераций';
}
